import { MARQUEE_ITEMS } from "./data";

const Leaf = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 shrink-0 text-[#86C89B]" aria-hidden="true">
    <path d="M12 2C6 7 6 17 12 22c6-5 6-15 0-20z" fill="currentColor" />
    <path d="M12 5v14" stroke="#0F2317" strokeWidth="1" />
  </svg>
);

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section className="marquee-wrap relative bg-[#1B3B28] py-8 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max items-center gap-10">
        {items.map((t, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className={`f-serif text-4xl sm:text-5xl whitespace-nowrap ${i % 2 ? "italic text-[#86C89B]" : "text-[#FCFBF7]"}`}>{t}</span>
            <Leaf />
          </span>
        ))}
      </div>
    </section>
  );
};
